import { EAccountPlansType } from "../../Enum/EAccountPlansType"

export class PlanUsageStatus {
  planType: EAccountPlansType

  subscriptionStatus: string

  currentMonthOrders: number

  monthlyOrdersLimit: number

  ordersUsagePercent: number

  currentProducts: number

  productsLimit: number

  productsUsagePercent: number

  isOrdersLimitReached: boolean

  isProductsLimitReached: boolean

  isOrdersNearLimit: boolean

  isProductsNearLimit: boolean

  usagePercent: number

  isLimitReached: boolean

  isNearLimit: boolean

  remainingOrders: number

  remainingProducts: number

  cycleStartUtc: Date

  cycleEndUtc: Date

  constructor(data: Partial<PlanUsageStatus>) {
    this.planType = data.planType ?? EAccountPlansType.None

    this.subscriptionStatus = data.subscriptionStatus ?? "pending"

    this.currentMonthOrders = data.currentMonthOrders ?? 0

    this.monthlyOrdersLimit = data.monthlyOrdersLimit ?? 0

    this.ordersUsagePercent = data.ordersUsagePercent ?? data.usagePercent ?? 0

    this.currentProducts = data.currentProducts ?? 0

    this.productsLimit = data.productsLimit ?? 0

    this.productsUsagePercent = data.productsUsagePercent ?? 0

    this.isOrdersLimitReached = data.isOrdersLimitReached ?? data.isLimitReached ?? false

    this.isProductsLimitReached = data.isProductsLimitReached ?? false

    this.isOrdersNearLimit = data.isOrdersNearLimit ?? data.isNearLimit ?? false

    this.isProductsNearLimit = data.isProductsNearLimit ?? false

    this.usagePercent = data.usagePercent ?? 0

    this.isLimitReached = data.isLimitReached ?? false

    this.isNearLimit = data.isNearLimit ?? false

    this.remainingOrders = data.remainingOrders ?? 0

    this.remainingProducts = data.remainingProducts ?? 0

    this.cycleStartUtc = data.cycleStartUtc ? new Date(data.cycleStartUtc) : new Date()

    this.cycleEndUtc = data.cycleEndUtc ? new Date(data.cycleEndUtc) : new Date()
  }
}
